<div class="inner">
  <div class="settings">
    <qai-call-button
      class="settings-button"
      [label]="('call.SETTINGS' | transloco)"
      kind="tertiary"
      icon="settings"
      (clicked)="handleSettingsClick()"
    />

    <qai-call-button
      class="captions-button"
      [label]="('call.CAPTIONS_LABEL' | transloco)"
      [kind]="isCaptionsOn() ? 'tertiary' : 'destructive'"
      [icon]="isCaptionsOn() ? 'captions' : 'captions-off'"
      (clicked)="handleCaptionsClick()"
    />
  </div>

  <div class="playback">
    <!-- Continue -->
    @if (showContinueButton()) {
      <div class="continue-button">
        <ng-content select="[qaiSlot='continue']"></ng-content>
      </div>
    }

    <!-- Vertical separator -->
    @if (showContinueButton() && showPauseButton()) {
      <div class="vertical-separator"></div>
    }

    <!-- Timer -->
    <div class="timer-row" [class.timer-no-continue]="showPauseButton() && !showContinueButton()">
      <qai-call-timer
        class="timer"
        [time]="time()"
        [canPause]="false"
      />
    </div>

    <!-- Vertical separator -->
    @if (!showContinueButton() && showPauseButton()) {
      <div class="vertical-separator"></div>
    }

    <!-- Pause Button Small -->
    @if (showPauseButton()) {
      <qai-call-button
        class="pause-small-button"
        [class.pause-no-continue]="showPauseButton() && !showContinueButton()"
        [label]="('call.PAUSE_LABEL' | transloco)"
        [kind]="'tertiary'"
        [icon]="isPaused() ? 'play' : 'pause'"
        (clicked)="handlePlaybackClick()"
      />
    }

    <!-- Pause Button Large -->
    @if (showContinueButton() && showPauseButton()) {
      <button
        class="pause-button"
        qai-button
        [shape]="'normal'"
        [kind]="'tertiary'"
        [size]="'medium'"
        [disabled]="!isPauseEnabled()"
        (click)="handlePlaybackClick()"
      >
        <qai-icon
          [kind]="isPaused() ? 'play-circle' : 'pause-circle'"
          positionStart
        />
        {{ isPaused() ? ('call.RESUME' | transloco) : ('call.PAUSE_LABEL' | transloco) }}
      </button>
    }

    <div class="screenshare-wrapper">
      <ng-content select="app-screenshare-button" />
    </div>

  </div>

  <div class="controls">
    <ng-content select="app-call-controls" />
  </div>
</div>
